import { EN_Phrases, TranslationKeys } from '../../../../translations';

const FIELD_TRANSLATION_PREFIXES: Record<string, string[]> = {
  eventSource: ['events.content.eventSource.'],
  eventFlowStatus: ['eventflow.category.'],
  pensionScheme: ['products.type.'],
  syncStatus: ['connection.processes.result.'],
};

const MUTATION_STATUS_TRANSLATION_PREFIX = 'pensioenbij.mutation.detail.status.';

const FIELD_LABEL_TRANSLATION_KEYS: Record<string, string> = {
  advisorkvk: TranslationKeys.pensioenbij_mutation_detail_field_advisorKvk,
  archived: TranslationKeys.pensioenbij_mutation_detail_field_archived,
  comment: TranslationKeys.pensioenbij_mutation_detail_field_comment,
  employeedateofbirth: TranslationKeys.pensioenbij_mutation_detail_field_employeeDateOfBirth,
  employeedateofemployment: TranslationKeys.pensioenbij_mutation_detail_field_employeeDateOfEmployment,
  employeedateofemploymentend: TranslationKeys.pensioenbij_mutation_detail_field_employeeDateOfEmploymentEnd,
  employeeemail: TranslationKeys.pensioenbij_mutation_detail_field_employeeEmail,
  employeeinitials: TranslationKeys.pensioenbij_mutation_detail_field_employeeInitials,
  employeelanguage: TranslationKeys.pensioenbij_mutation_detail_field_employeeLanguage,
  employeename: TranslationKeys.pensioenbij_mutation_detail_field_employeeName,
  employeerefid: TranslationKeys.pensioenbij_mutation_detail_field_employeeRefId,
  employerkvk: TranslationKeys.pensioenbij_mutation_detail_field_employerKvk,
  employername: TranslationKeys.pensioenbij_mutation_detail_field_employerName,
  employerpolicyplanid: TranslationKeys.pensioenbij_mutation_detail_field_employerPolicyPlanId,
  eventflowstatus: TranslationKeys.pensioenbij_mutation_detail_field_eventFlowStatus,
  eventsource: TranslationKeys.pensioenbij_mutation_detail_field_eventSource,
  id: TranslationKeys.pensioenbij_mutation_detail_field_id,
  insurername: TranslationKeys.pensioenbij_mutation_detail_field_insurerName,
  pensionscheme: TranslationKeys.pensioenbij_mutation_detail_field_pensionScheme,
  processed: TranslationKeys.pensioenbij_mutation_detail_field_processed,
  productname: TranslationKeys.pensioenbij_mutation_detail_field_productName,
  socialsecuritynumber: TranslationKeys.pensioenbij_mutation_detail_field_socialSecurityNumber,
  updatedat: TranslationKeys.pensioenbij_mutation_detail_field_updatedAt,
};

const BOOLEAN_TRANSLATION_CANDIDATES: Record<'true' | 'false', string[]> = {
  true: ['true', 'yes'],
  false: ['false', 'no'],
};

const getTranslationIdIfExists = (id: string) => (Object.hasOwn(EN_Phrases, id) ? id : null);

export const getPensioenbijAutoValueTranslationId = (field: string, value: unknown) => {
  if (typeof value === 'boolean') {
    const candidates = BOOLEAN_TRANSLATION_CANDIDATES[value ? 'true' : 'false'];

    for (const candidate of candidates) {
      const translationId = getTranslationIdIfExists(candidate);
      if (translationId) return translationId;
    }

    return null;
  }

  if (typeof value !== 'string') return null;

  const prefixes = FIELD_TRANSLATION_PREFIXES[field];
  if (!prefixes?.length) return null;

  for (const prefix of prefixes) {
    const translationId = getTranslationIdIfExists(`${prefix}${value}`);
    if (translationId) return translationId;
  }

  return null;
};

export const getPensioenbijMutationStatusTranslationId = (status: string | null | undefined) =>
  status ? getTranslationIdIfExists(`${MUTATION_STATUS_TRANSLATION_PREFIX}${status}`) : null;

export const getPensioenbijFieldLabelTranslationId = (field: string) =>
  FIELD_LABEL_TRANSLATION_KEYS[field.toLowerCase()] ?? null;
